module.exports = __webpack_public_path__ + "img/031-corsica.c8eefee8.svg";